<template>
  <question
    prevTitle="Cancel"
    nextTitle="Continue"
    :prevEnabled="true"
    :nextEnabled="buttonEnabled"
    @prevClick="cancel"
    @nextClick="next">
    <div class="stretchBox">
      <div class="detailBox rounded shadow">
        <h3>What type of company are you?</h3>
        <select v-model="selected">
          <option v-for="(item, index) in companyTypes" :key="index">
            {{ item }}
          </option>
        </select>
      </div>
    </div>
  </question>
</template>

<style lang="scss" scoped>
.stretchBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading {
  width: 30vw;
  @media screen and (orientation: portrait) {
    width: 100vw;
  }
}
.searchBar {
  background-color: var(--base-colour, #535450);
  display: grid;
  grid-template-columns: auto auto;
}
.searchButton {
  // border-radius: 0 0 1.5em 1.5em;
  background-color: var(--base-colour, #535450);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0.5em;
  padding-right: 1em;
  &:hover {
    background-color: var(--hover-colour, #bbbbbb);
  }
}
</style>
<script>
import question from "@/components/questionTemplate";
export default {
  props: {
    nextRoute: {
      type: String,
      default: "12",
    },
  },
  components: {
    question,
  },
  methods: {
    cancel: function () {
      if (this.lastRoute) {
        this.$router.push("/");
      } else {
        this.$router.go(-1);
      }
    },
    next: function () {
      this.$store.dispatch("setFormData", {
        companyType: this.selected
      });
      this.$router.push(this.nextRoute);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.lastRoute = from;
    });
  },
  data: function () {
    return {
      companyName: "",
      companyReg: "",
      findingData: false,
      findingEnabled: true,
      response: "",
      lastRoute: null,
      selected: "Select Company Type",
      companyTypes: [
        "Select Company Type",
        "Limited Company",
        "LLP",
        "Partnership",
        "Sole Trader",
      ],
    };
  },
  computed: {
    companyData: function () {
      return this.$store.state.companyData;
    },
    buttonEnabled: function () {
      return this.selected !== "Select Company Type"
    },
  },
};
</script>